import ProfessionalProvider from "models/resource-management/professional-provider";

interface PatientAllergyBase {
  allergyType: string;
  allergyName: string;
  allergyId: string;
}
interface PatientAllergy extends PatientAllergyBase {
  tenantId: number;
  patientChartId: number;
  severity?: string;
  reaction?: string;
  reactionOther?: string;
  createdBy: number;
  modifiedBy: number;
  deletedBy: number;
  createdDatetime: string;
  createdTimezone: string;
  modifiedDatetime: string;
  modifiedTimezone: string;
  isDeleted: boolean;
  historyMetaData: AllergyHistory[];
  isLegacyPatient: boolean;
  selected: boolean;
  latestDate: string;
  latestTimeZone: string;
  createdName: string;
  originalHistorySelected: boolean;
  originalHistory: AllergyOriginalHistory;
  lastEditedBy: number;
  scriptSureData: PatientAllergyScriptSureData;
}

interface AllergyOriginalHistory {
  allergyName: string;
  allergyType: string;
  severity: string;
  reaction: string;
  reactionOther?: string;
}

interface PatientAllergyEdit extends PatientAllergyBase {
  allergyType: string;
  allergyName: string;
  allergyId: string;
  severity: string;
  reaction: string;
  reactionOther?: string;
  reasonForChange: string;
  modifiedTimezone: string;
  scriptSureData: PatientAllergyScriptSureData;
}

interface PatientAllergyDelete extends PatientAllergyBase {
  allergyType: string;
  allergyName: string;
  allergyId: string;
  reasonForDelete: string;
  modifiedTimezone: string;
}

interface AllergyHistory {
  changesMadeTo: string;
  previousValue: string;
  modifiedBy: number;
  modifiedDatetime: string;
  modifiedTimezone: string;
  reasonForChange: string;
}
interface AllergyResults {
  patientAllergy: PatientAllergy[];
  professionalProviders: Map<number, ProfessionalProvider | string>;
}
interface AllergyLookup {
  conceptType: string;
  name: string;
  mediSpanId: string;
  value: string;
}
interface AllergyConfiguration {
  id: number;
  schedule: string;
  description: string;
  admissionType: string;
  standardTimes: string;
  standardTimesArray: string[];
}

interface PatientAllergyScriptSureData {
  allergyType: string;
  allergyId: string;
  routedMedId: number;
  reactionId: number;
  severityId: number;
}

export const PatientAllergyChangeTypes: ChangeTypeData[] = [
  {
    changesMadeTo: "Name/Description",
    field: "allergyName",
  },
  {
    changesMadeTo: "Type",
    field: "allergyType",
  },
  {
    changesMadeTo: "Reaction",
    field: "reaction",
  },
  {
    changesMadeTo: "Severity",
    field: "severity",
  },
];
export interface ChangeTypeData {
  changesMadeTo: string;
  field: string;
}

export {
  AllergyConfiguration,
  AllergyLookup,
  PatientAllergyBase,
  PatientAllergy,
  PatientAllergyEdit,
  PatientAllergyDelete,
  AllergyResults,
  AllergyHistory,
  AllergyOriginalHistory,
  PatientAllergyScriptSureData,
};



// WEBPACK FOOTER //
// ./src/pages/patient-chart/allergies/patient-allergies.ts